// @dev : temporarily change branch here when testing changes in chaindata
const CHAINDATA_BRANCH = "main";

//
// Chaindata published files (dist folder)
//

const chaindataUrl = `https://raw.githubusercontent.com/TalismanSociety/chaindata/${CHAINDATA_BRANCH}/dist`;
const chaindataChainsAllUrl = `${chaindataUrl}/chains/all.json`;
const chaindataChainsSummaryUrl = `${chaindataUrl}/chains/summary.json`;
const chaindataChainByIdUrl = chainId => `${chaindataUrl}/chains/byId/${chainId}.json`;
const chaindataChainByGenesisHashUrl = genesisHash => `${chaindataUrl}/chains/byGenesisHash/${genesisHash}.json`;
const chaindataEvmNetworksAllUrl = `${chaindataUrl}/evmNetworks/all.json`;
const chaindataEvmNetworksSummaryUrl = `${chaindataUrl}/evmNetworks/summary.json`;
const chaindataEvmNetworkByIdUrl = evmNetworkId => `${chaindataUrl}/evmNetworks/byId/${evmNetworkId}.json`;
const chaindataTokensAllUrl = `${chaindataUrl}/tokens/all.json`;
const chaindataTokenByIdUrl = tokenId => `${chaindataUrl}/tokens/byId/${tokenId}.json`;
const chaindataMiniMetadatasAllUrl = `${chaindataUrl}/miniMetadatas/all.json`;

//
// GitHub Repo Constants
//

const githubApi = "https://api.github.com";
const githubChaindataOrg = "TalismanSociety";
const githubChaindataRepo = "chaindata";
const githubChaindataBranch = CHAINDATA_BRANCH;
const githubChaindataBaseUrl = `https://raw.githubusercontent.com/${githubChaindataOrg}/${githubChaindataRepo}/${githubChaindataBranch}`;
const githubChainsUrl = `${githubChaindataBaseUrl}/data/chaindata.json`;
const githubTestnetChainsUrl = `${githubChaindataBaseUrl}/data/testnets-chaindata.json`;
const githubEvmNetworksUrl = `${githubChaindataBaseUrl}/data/evm-networks.json`;
const githubChaindataChainsAssetsDir = "assets/chains";
const githubChaindataTokensAssetsDir = "assets/tokens";
const githubChainLogoUrl = chainId => `${githubChaindataBaseUrl}/${githubChaindataChainsAssetsDir}/${chainId}.svg`;
const githubEvmNetworkLogoUrl = networkId => `${githubChaindataBaseUrl}/${githubChaindataChainsAssetsDir}/${networkId}.svg`;
const githubTokenLogoUrl = tokenId => `${githubChaindataBaseUrl}/${githubChaindataTokensAssetsDir}/${tokenId}.svg`;
const githubUnknownChainLogoUrl = githubChainLogoUrl("unknown");
const githubUnknownTokenLogoUrl = githubTokenLogoUrl("unknown");

const fetchChains = async () => await (await fetch(chaindataChainsAllUrl)).json();
const fetchChain = async chainId => await (await fetch(chaindataChainByIdUrl(chainId))).json();
const fetchEvmNetworks = async () => await (await fetch(chaindataEvmNetworksAllUrl)).json();
const fetchEvmNetwork = async evmNetworkId => await (await fetch(chaindataEvmNetworkByIdUrl(evmNetworkId))).json();
const fetchTokens = async () => await (await fetch(chaindataTokensAllUrl)).json();
const fetchToken = async tokenId => await (await fetch(chaindataTokenByIdUrl(tokenId))).json();
const fetchMiniMetadatas = async () => await (await fetch(chaindataMiniMetadatasAllUrl)).json();
const availableTokenLogoFilenames = async () => (await fetch(`${githubApi}/repos/${githubChaindataOrg}/${githubChaindataRepo}/contents/${githubChaindataTokensAssetsDir}`).then(response => response.json())).flatMap(entry => {
  if (typeof entry !== "object" || entry === null) return [];
  if (!("name" in entry) || typeof entry.name !== "string") return [];
  return entry.name;
});

export { githubEvmNetworksUrl as A, githubChaindataChainsAssetsDir as B, githubChaindataTokensAssetsDir as C, githubChainLogoUrl as D, githubEvmNetworkLogoUrl as E, githubUnknownChainLogoUrl as F, fetchMiniMetadatas as G, availableTokenLogoFilenames as H, fetchToken as a, fetchEvmNetwork as b, fetchChains as c, fetchEvmNetworks as d, githubUnknownTokenLogoUrl as e, fetchChain as f, githubTokenLogoUrl as g, fetchTokens as h, chaindataUrl as i, chaindataChainsAllUrl as j, chaindataChainsSummaryUrl as k, chaindataChainByIdUrl as l, chaindataChainByGenesisHashUrl as m, chaindataEvmNetworksAllUrl as n, chaindataEvmNetworksSummaryUrl as o, chaindataEvmNetworkByIdUrl as p, chaindataTokensAllUrl as q, chaindataTokenByIdUrl as r, chaindataMiniMetadatasAllUrl as s, githubApi as t, githubChaindataOrg as u, githubChaindataRepo as v, githubChaindataBranch as w, githubChaindataBaseUrl as x, githubChainsUrl as y, githubTestnetChainsUrl as z };
